import React, { Component } from 'react'
import { BlocklyWorkspace } from 'react-blockly';
import '@blockly/block-plus-minus';

export default class BlocklyWS extends Component {
    constructor(props) {
        super(props)
        this.initialXml = "<xml xmlns='https://developers.google.com/blockly/xml'> <block type='start' id='-[IJV4B]*tJHCF12j?OR' deletable='false' x='100' y='120'/></xml>"
        this.toolboxCategories = props.blockProvider.getToolboxCategories()
        this.state = {"initialXml": this.initialXml}
        this.setWorkspaceXml = this.setWorkspaceXml.bind(this)
        // workspaceID is used to force reloading of workspace on loading of file, because key change forces reload
        this.workspaceID = 0
    }

    setWorkspaceXml(xml)  {
        this.workspaceID += 1
        this.setState({"initialXml": xml})
    }
    render() {
        return (
            <BlocklyWorkspace
            className="blockly-workspace"
            toolboxConfiguration={this.toolboxCategories} 
            key={this.workspaceID}
            initialXml={this.state.initialXml}
            onXmlChange={this.props.programCollector.onWSXMLChange}
          />
              )
    }
}
